<template>
  <div class="case page-shell">
    <banner
      title="经典案例"
      eyebrow="Successful Projects"
      desc="宇飞智能服务酒店、口岸、航空基地、商业综合体、公共公园等多类型场景，用稳定产品和云端平台支撑高频通行。"
    />

    <section class="section-wrap case-section">
      <div class="section-head">
        <div>
          <p class="section-kicker">PROJECT LIBRARY</p>
          <h2 class="section-title">真实项目，验证智慧通行能力</h2>
        </div>
        <p class="section-desc">每一个案例都围绕效率、安全、运营和体验做系统化升级。</p>
      </div>

      <div class="case-grid">
        <router-link
          v-for="item in caseList"
          :key="item.id + item.title"
          class="case-card"
          :to="{ name: 'casedetails', params: item }"
        >
          <div class="case-card__image" v-lazy:background-image="item.Img">
            <span>{{ item.CreateTime }}</span>
          </div>
          <div class="case-card__body">
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
            <strong>查看项目详情</strong>
          </div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import site from "../static/siteData";

export default {
  name: "Case",
  components: {
    Banner
  },
  data() {
    return {
      caseList: site.cases
    };
  }
};
</script>

<style lang="scss" scoped>
.case-section {
  padding: 76px 0 92px;
}

.section-head {
  margin-bottom: 34px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 36px;
}

.section-desc {
  max-width: 430px;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.case-card {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.case-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.14);
}

.case-card__image {
  position: relative;
  height: 260px;
  background-position: center;
  background-size: cover;
}

.case-card__image::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(4, 17, 42, 0.08), rgba(4, 17, 42, 0.48));
}

.case-card__image span {
  position: absolute;
  left: 18px;
  bottom: 18px;
  z-index: 1;
  padding: 6px 12px;
  border-radius: 99px;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  background: rgba(22, 119, 255, 0.86);
}

.case-card__body {
  padding: 24px;
}

.case-card h3 {
  color: #071a35;
  font-size: 22px;
}

.case-card p {
  min-height: 78px;
  margin-top: 12px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.8;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.case-card strong {
  display: inline-block;
  margin-top: 20px;
  color: #1677ff;
  font-size: 14px;
}

@media (max-width: 900px) {
  .section-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .case-section {
    padding: 56px 0 70px;
  }

  .case-grid {
    grid-template-columns: 1fr;
  }
}
</style>
